export default __webpack_public_path__ + "static/media/left_bush.b4004bd2.svg";